import { connect } from 'react-redux';

import View from './NextView';
import { currentClientId, isInSummaryEditSelector } from '../../AdvWorkflow/AdvWorkflowSelector';
import {
  jump,
  save,
  updateValidation,
  DO_BACKUP,
  depthFirstJump,
} from '../../AdvWorkflow/AdvWorkflowActions';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';
import { setDirtyFlagForAll } from '../../AdvWorkflow/AdvWorkflowCacheActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  isInSummaryEdit: isInSummaryEditSelector(state, ownProps),
  nextIterators: ownProps.nextIterators,
});
const mapDispatchToProps = dispatch => ({
  onBackToSummary: (
    validationId,
    validator,
    backendKey,
    clientId,
    workflowId,
    doNotSave,
    onPostProcess,
    onPostSave,
    validatedOnClick,
    nextIterators,
    dirtyGraphNodes,
  ) => () => {
    if (validationId) {
      const errors = validator();
      dispatch(updateValidation(buildMutation(validationId, errors), workflowId, clientId));
      if (errors.length) {
        return;
      }
    }
    if (doNotSave) {
      dispatch({
        type: DO_BACKUP,
        workflowId,
        clientId,
      });
      dispatch(setDirtyFlagForAll(dirtyGraphNodes));
      dispatch(depthFirstJump(workflowId, nextIterators));
      validatedOnClick();
      return;
    }
    const onSuccess = () => {
      dispatch(setDirtyFlagForAll(dirtyGraphNodes));
      dispatch(depthFirstJump(workflowId, nextIterators));
      validatedOnClick();
    };

    dispatch(save(
      backendKey,
      onSuccess,
      (errors) => {
        if (validationId) {
          dispatch(updateValidation(buildMutation(validationId, errors), workflowId, clientId));
        } else {
          throw Error('There is no validationId provided for this workflow step and the BE returned validation errors that should be shown');
        }
      },
      workflowId,
      clientId,
      false,
      onPostProcess,
      onPostSave,
    ));
  },
  onNext: (
    validationId,
    validator,
    backendKey,
    clientId,
    workflowId,
    doNotSave,
    onPostProcess,
    onPostSave,
    validatedOnClick,
    dirtyGraphNodes,
  ) => () => {
    if (validationId) {
      const errors = validator();
      dispatch(updateValidation(buildMutation(validationId, errors), workflowId, clientId));
      if (errors.length) {
        return;
      }
    }
    if (doNotSave) {
      dispatch({
        type: DO_BACKUP,
        workflowId,
        clientId,
      });
      dispatch(setDirtyFlagForAll(dirtyGraphNodes));
      dispatch(jump(1, workflowId, clientId));
      validatedOnClick();
      return;
    }

    const onSuccess = () => {
      dispatch(setDirtyFlagForAll(dirtyGraphNodes));
      dispatch(jump(1, workflowId, clientId));
      validatedOnClick();
    };

    dispatch(save(
      backendKey,
      onSuccess,
      (errors) => {
        if (validationId) {
          dispatch(updateValidation(buildMutation(validationId, errors), workflowId, clientId));
        } else {
          throw Error('There is no validationId provided for this workflow step and the BE returned validation errors that should be shown');
        }
      },
      workflowId,
      clientId,
      false,
      onPostProcess,
      onPostSave,
    ));
  },
  onSkip: workflowId => dispatch(jump(1, workflowId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
